module.exports = __webpack_public_path__ + "static/img/case6.2fb5754c.jpg";